import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, FormControl, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CollectProlificIdView = ({ open, onClose, onSubmit} : {open: boolean, onClose: () => void, onSubmit: (values: string) => void}) => {
  const [prolificId, setProlificId] = useState<string>("");
  const { t } = useTranslation();
  
  const isValidProlificId = (id: string) => /^[a-z0-9]{24}$/.test(id);
  const handleSubmit = (prolificId: string) => {
    onSubmit(prolificId);
    onClose();
  };

  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogContent>
        <Typography>
          {t("Please enter your Prolific ID:")}
        </Typography>

        <FormControl fullWidth margin="normal">
          <TextField
            label={t("Prolific ID")}
            aria-label={t("Prolific ID")}
            fullWidth
            value={prolificId}
            onChange={e => setProlificId(e.target.value)}
            inputProps={{ maxLength: 24 }}
            error={prolificId.length > 0 && !isValidProlificId(prolificId)}
            helperText={
              prolificId.length > 0 && !isValidProlificId(prolificId)
                ? t("Must be 24 lowercase letters or numbers.")
                : ""
            }
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" autoFocus onClick={() => handleSubmit(prolificId)} disabled={!isValidProlificId(prolificId)}>
          {t("Submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CollectProlificIdView;
